// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  position: relative;
  min-height: 100%;
  overflow-x: hidden;
}

body {
  width:100%;
}

/* From here we override global bootstrap variable. You can see all root variables
 at https://getbootstrap.com/docs/5.3/customize/css-variables/ */

:root,
[data-bs-theme=light] {
  --bs-font-sans-serif: 'Poppins', 'Manrope', Helvetica, sans-serif;
  --bs-body-font-size: 0.92rem;

  /* Light Farbschema */
  color-scheme: light;

  /* Schriftart und Basiseinstellungen */
  --bs-font-sans-serif: 'Poppins', 'Manrope', Helvetica, sans-serif;
  --bs-body-font-size: 0.92rem;

  /* Farbvariablen für ein helles Schema */
  --primary-color: rgb(59, 125, 221); /* Standard-Bootstrap-Blau */
  --primary-light: #009EFF; /* Heller Farbton des Primärfarben */
  --primary-lighter: #81adff; /* Ehemalig war das #7FB7F2 */
  --primary-dark: #005CBF; /* Heller Farbton des Primärfarben */
  --primary-darker: #354C80; /* Heller Farbton des Primärfarben */
  --blue-color: #004085;   /* Tiefes Blau für Header und Akzente */
  --secondary-color: #6c757d; /* Bootstrap-Dunkelgrau für Sekundärfarben */
  --success-color: #e3e3e3; /* Bootstrap-Grün für Erfolgsfarben */
  --info-color: #D1E8F0; /* Bootstrap-Hellblau für Infofarben */
  --warning-color: #FFC800; /* Bootstrap-Gelb für Warnungen */
  --danger-color: #811211;  /* Bootstrap-Rot für Fehlertexte */
  --dark-color: #343a40;    /* Dunkles Grau für Texte und Header */



  /* Helle Grautöne (angepasst an Bootstrap-Standards) */

  --bs-gray-main: #f8f8f8;   /* für den standart main hintergund auf allen seiten */
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;   /* Standard Bootstrap-Grau */
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;   /* Tiefstes Grau für dunkle Akzente */
  --bs-gray-middle: #4B5966;


}

:root,
[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-font-sans-serif: 'Poppins','Manrope', Helvetica, sans-serif;
  --bs-body-font-size: 0.92rem;
}

/* From here we override default bootstrap styles. This should only be done when there was no solution
  to override the default styles using the bootstrap variables or using the boostrap classes. */


/* Shop Styles von Flo */

:root {
  --tenant-primary-color: #ed644c; /* Primary color for the tenant. Is overwritten in the layout file with the color from the backend */
}

body {
  font-family: 'Poppins', sans-serif; /* Sets the default font */
}

/* Definiere globale Variablen */
:root {
  --custom-gray: #757575; /* Dein gewählter Grauton */
}



/* Schriftformate für die Fotopakete */

.packproduct-title {
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: rgb(75, 89, 102);
}

.packproduct-sub {
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: rgb(75, 89, 102);
}

.packproduct-subblack {
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: black;
}

.packproduct-price {
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: white;
}

.packproduct-price2 {
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: white;
}

.packproduct-price-old {
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: rgb(119, 119, 119);
}

/* Schriftformate Einzelprodukte */

.text-button1 {
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: rgb(119, 119, 119);
  letter-spacing: 0.10px; /* Fügt einen Abstand von 1 Pixel zwischen den Zeichen hinzu */
}

.text-button1Price {
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  font-weight: 400;
  color: rgb(33, 37, 41);
  letter-spacing: 0.32px;
}


/* Schriftformate für Shop Global */


.section-head {
  font-family: 'Poppins', sans-serif;
  font-size: 22px;
  font-weight: 600;
  color: rgb(75, 89, 102);
}

.button-textinv {
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: white;
}

.button-text {
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: rgb(75, 89, 102);
  letter-spacing: 0.60px;
}

/* Schriftformate für Shop*/

.fs-photog-head1 {
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 400;
}

.fs-photog-PackPrice {
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 400;
}


.fs-photog-13-200 {
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 200;
}

.fs-photog-14-200 {
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 200;
}

.fs-photog-15-200 {
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  font-weight: 200;
}

.fs-photog-16-200 {
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 200;
}

.fs-photog-18-200 {
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 200;
}

.fs-photog-20-200 {
  font-family: 'Poppins', sans-serif;
  font-size: 20px;
  font-weight: 200;
}

.fs-photog-20-300 {
  font-family: 'Poppins', sans-serif;
  font-size: 20px;
  font-weight: 300;
}


.fs-photog-20-700 {
  font-family: 'Poppins', sans-serif;
  font-size: 20px;
  font-weight: 700;
}


.fs-photog-30-200 {
  font-family: 'Poppins', sans-serif;
  font-size: 30px;
  font-weight: 200;
}







.fs-photog-12-400 {
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  font-weight: 400;
}

.fs-photog-12-600 {
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  font-weight: 600;
}

.fs-photog-13-300 {
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 300;
}
.fs-photog-13-400 {
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 400;
}



.fs-photog-13-600 {
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 600;
}

.fs-photog-14-300 {
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 300;
}


.fs-photog-14-400 {
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 400;
}

.fs-photog-14-600 {
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 600;
}


.fs-photog-15-300 {
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  font-weight: 300;

}


.fs-photog-15-500 {
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.32px;
}

.fs-photog-15-600 {
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.32px;
}


.fs-photog-16-600 {
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 600;
}

.fs-photog-16-400 {
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 400;
}



.fs-photog-24-200 {
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
  font-weight: 200;
}
.fs-photog-24-300 {
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
  font-weight: 300;
}


.fs-photog-24-400 {
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
  font-weight: 400;
}

.fs-photog-24-600 {
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
  font-weight: 600;
}

.fs-photog-24-800 {
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
  font-weight: 800;
}

.fs-photog-24-900 {
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
  font-weight: 900;
}

.fs-photog-30-400 {
  font-family: 'Poppins', sans-serif;
  font-size: 30px;
  font-weight: 400;
}




.fs-photog-18b {
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 600;
}


.fs-photog-20-400 {
  font-family: 'Poppins', sans-serif;
  font-size: 20px;
  font-weight: 400;
}


.fs-photog-17-500 {
  font-family: 'Poppins', sans-serif;
  font-size: 17px;
  font-weight: 500;
  letter-spacing: 0.60px;
}

.fs-photog-30-200 {
  font-family: 'Poppins', sans-serif;
  font-size: 30px;
  font-weight: 200;
}


.fs-photog-16-300-button {
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0.40px;
}






/* Textcolor */

.text-photog {
  color: #ed644c; /* Photographer Color */
}

.text-shopgray {
  color: var(--custom-gray); /* Verwende den Grauton für Text */
}


.text-color1 {
  color: rgb(33, 37, 41);
}

.text-lightgray {
  color: rgb(119, 119, 119);
}

.text-middlegray {
  color: rgb(75, 89, 102);
}



/* Background color */
.bg-photog {
  background-color: var(--tenant-primary-color); /* Photographer Color */
}

.bg-shopgray {
  background-color: var(--custom-gray); /* Verwende den Grauton als Hintergrundfarbe */
}

.bg-gray-100 {
  background-color: var(--bs-gray-100); /* Verwende den Grauton als Hintergrundfarbe */
}
.bg-gray-200 {
  background-color: var(--bs-gray-200); /* Verwende den Grauton als Hintergrundfarbe */
}

.bg-lightgray {
  background-color: rgb(119, 119, 119);
}





/* border outline */
.border-outline {
  border: 1px solid rgb(33, 37, 41); /* Breite, Stil und Farbe der Border */
}









/* Button */

.btn-shopgray {
  background-color: #dedede; /* Verwende den Grauton als Hintergrundfarbe */
  transition: opacity 0.3s ease; /* Glatter Übergang für Opazität */
}
  .btn-shopgray:hover {
    background-color: #dedede; /* Verwende den Grauton als Hintergrundfarbe */
    opacity: 0.7;
  }



.btn-shopgrayMed {
  background-color: rgb(75, 89, 102); /* Verwende den Grauton als Hintergrundfarbe */
}

.btn-photogColour {
  background-color: var(--tenant-primary-color); /* Photographer Color */
  transition: opacity 0.3s ease; /* Glatter Übergang für Opazität */
}


  .btn-photogColour:hover {
    background-color: rgb(119, 119, 119);
    opacity: 0.5;
  }


.hover-effect {
  text-decoration: none;
}

  .hover-effect:hover {
    color: #a0a0a0; /* Ändern Sie die Farbe nach Ihren Wünschen */
  }


/* ---------------------custom-radio for the Favourite Buttons in the Single-Foto Section*/
.custom-radio {
  padding: 7px;
  border: 1px solid #ccc;
  border-radius: 0.25rem;
  display: block;
  width: 100%;
  text-align: left;
  background-color: #f8f9fa;
  color: #212529;
  cursor: pointer;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}

  .custom-radio:hover {
    background-color: #e2e6ea;
  }

input[type="radio"]:checked + .custom-radio {
  /*  background-color: var(--tenant-primary-color);*/ /* Blauer Hintergrund, wenn ausgewählt */
  background-color: white;
  /*color: white;*/
  border: 2px solid var(--tenant-primary-color) !important; /* Schwarze Border */
}

.custom-radio input[type="radio"] {
  margin-right: 10px;
}

.custom-radio-price {
  display: block;
  font-size: 0.9rem;
  color: #007bff;
}











/* Button Bild Tauschen überm Foto */





/* Dicke Linie */
.thick-divider {
  border-top: 10px solid var(--custom-gray); /* Verwende die definierte Variable */
}

.normal-divider {
  border-top: 3px solid var(--custom-gray); /* Verwende die definierte Variable */
}




.square-container {
  width: 100%; /* Setzt die Breite des Containers auf 100% des übergeordneten Elements */
  aspect-ratio: 1; /* 1:1 Verhältnis */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden; /* Verhindert, dass Inhalte außerhalb des Containers angezeigt werden */
}





.img-singleProduct {
  max-width: 100%; /* Sorgt dafür, dass das Bild maximal so breit wie der Container ist */
  max-height: 100%; /* Sorgt dafür, dass das Bild maximal so hoch wie der Container ist */
  object-fit: contain; /* Verhindert, dass das Bild verzerrt wird */
}

/* ----------Flo new May 2025--------------------*/

.card-product {
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid #ededed;
  overflow-x: hidden;
  background-color: white;
}
.card-bl-flex {
  border-radius: 12px;
  padding: 25px 23px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid #ededed;
}



h3 {
  font-family: 'Poppins', sans-serif !important;
  font-size: 24px !important;
  font-weight: 800 !important;
  color: var(--bs-gray-middle) !important;
  margin: 0 !important;
}


p {
  font-family: 'Poppins', sans-serif !important;
  font-size: 14px !important;
  font-weight: 300 !important;
  color: var(--bs-gray-middle) !important;
  margin: 0 !important;
  padding: 0 !important;
}

.text-body-light {
  font-family: 'Poppins', sans-serif !important;
  font-size: 14px !important;
  font-weight: 300 !important;
  color: var(--bs-gray-middle) !important;
}

.text-btn {
  font-family: 'Poppins', sans-serif !important;
  font-size: 15px !important;
  font-weight: 400 !important;
  color: var(--bs-gray-middle);
}



.text-body-bold {
  font-family: 'Poppins', sans-serif !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  color: var(--bs-gray-middle) !important;
}

.btn-height {
  height: 35px !important;
  display: flex !important;
  align-items: center !important;
  margin:0 !important;
  padding:0 !important;
}

.product-small {
  max-height: 80%;
  max-width: 80%;
}

.product-medium {
  max-height: 90%;
  max-width: 90%;
}

.product-large {
  max-height: 100%;
  max-width: 100%;
}

.test-mode-banner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2000;
}


.mt-custom {
  margin-top: calc(60px + 40px);
}

.fixed-header {
  top: 40px;
}
`, "",{"version":3,"sources":["webpack://./Areas/Shop/Client/css/site.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;gEACgE;;AAEhE;;EAEE,iEAAiE;EACjE,4BAA4B;;EAE5B,qBAAqB;EACrB,mBAAmB;;EAEnB,sCAAsC;EACtC,iEAAiE;EACjE,4BAA4B;;EAE5B,wCAAwC;EACxC,kCAAkC,EAAE,4BAA4B;EAChE,wBAAwB,EAAE,oCAAoC;EAC9D,0BAA0B,EAAE,6BAA6B;EACzD,uBAAuB,EAAE,oCAAoC;EAC7D,yBAAyB,EAAE,oCAAoC;EAC/D,qBAAqB,IAAI,uCAAuC;EAChE,0BAA0B,EAAE,4CAA4C;EACxE,wBAAwB,EAAE,qCAAqC;EAC/D,qBAAqB,EAAE,sCAAsC;EAC7D,wBAAwB,EAAE,iCAAiC;EAC3D,uBAAuB,GAAG,kCAAkC;EAC5D,qBAAqB,KAAK,sCAAsC;;;;EAIhE,sDAAsD;;EAEtD,uBAAuB,IAAI,sDAAsD;EACjF,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB,IAAI,4BAA4B;EACtD,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB,IAAI,qCAAqC;EAC/D,yBAAyB;;;AAG3B;;AAEA;;EAEE,kBAAkB;EAClB,gEAAgE;EAChE,4BAA4B;AAC9B;;AAEA;+FAC+F;;;AAG/F,wBAAwB;;AAExB;EACE,+BAA+B,EAAE,oGAAoG;AACvI;;AAEA;EACE,kCAAkC,EAAE,0BAA0B;AAChE;;AAEA,gCAAgC;AAChC;EACE,sBAAsB,EAAE,2BAA2B;AACrD;;;;AAIA,sCAAsC;;AAEtC;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,kCAAkC;;AAElC;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB,EAAE,8DAA8D;AACxF;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;;AAGA,mCAAmC;;;AAGnC;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,2BAA2B;;AAE3B;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;;;;;;;AAQA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;;;AAIA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;;AAElB;;;AAGA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;;AAGA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;;;AAIA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;;;;AAKA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;;;;;;AAOA,cAAc;;AAEd;EACE,cAAc,EAAE,uBAAuB;AACzC;;AAEA;EACE,yBAAyB,EAAE,kCAAkC;AAC/D;;;AAGA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;;;AAIA,qBAAqB;AACrB;EACE,6CAA6C,EAAE,uBAAuB;AACxE;;AAEA;EACE,oCAAoC,EAAE,8CAA8C;AACtF;;AAEA;EACE,oCAAoC,EAAE,8CAA8C;AACtF;AACA;EACE,oCAAoC,EAAE,8CAA8C;AACtF;;AAEA;EACE,oCAAoC;AACtC;;;;;;AAMA,mBAAmB;AACnB;EACE,iCAAiC,EAAE,sCAAsC;AAC3E;;;;;;;;;;AAUA,WAAW;;AAEX;EACE,yBAAyB,EAAE,8CAA8C;EACzE,6BAA6B,EAAE,kCAAkC;AACnE;EACE;IACE,yBAAyB,EAAE,8CAA8C;IACzE,YAAY;EACd;;;;AAIF;EACE,kCAAkC,EAAE,8CAA8C;AACpF;;AAEA;EACE,6CAA6C,EAAE,uBAAuB;EACtE,6BAA6B,EAAE,kCAAkC;AACnE;;;EAGE;IACE,oCAAoC;IACpC,YAAY;EACd;;;AAGF;EACE,qBAAqB;AACvB;;EAEE;IACE,cAAc,EAAE,6CAA6C;EAC/D;;;AAGF,0FAA0F;AAC1F;EACE,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,8EAA8E;AAChF;;EAEE;IACE,yBAAyB;EAC3B;;AAEF;EACE,mDAAmD,EAAE,wCAAwC;EAC7F,uBAAuB;EACvB,gBAAgB;EAChB,wDAAwD,EAAE,oBAAoB;AAChF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;;;;;;;;;;;AAYA,oCAAoC;;;;;;AAMpC,gBAAgB;AAChB;EACE,yCAAyC,EAAE,qCAAqC;AAClF;;AAEA;EACE,wCAAwC,EAAE,qCAAqC;AACjF;;;;;AAKA;EACE,WAAW,EAAE,yEAAyE;EACtF,eAAe,EAAE,mBAAmB;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB,EAAE,uEAAuE;AAC3F;;;;;;AAMA;EACE,eAAe,EAAE,sEAAsE;EACvF,gBAAgB,EAAE,qEAAqE;EACvF,mBAAmB,EAAE,4CAA4C;AACnE;;AAEA,kDAAkD;;AAElD;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;AAC3B;;;;AAIA;EACE,6CAA6C;EAC7C,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;EACvC,oBAAoB;AACtB;;;AAGA;EACE,6CAA6C;EAC7C,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;EACvC,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,6CAA6C;EAC7C,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,6CAA6C;EAC7C,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;;;AAIA;EACE,6CAA6C;EAC7C,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;AACf;;;AAGA;EACE,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX","sourcesContent":["html {\n  position: relative;\n  min-height: 100%;\n  overflow-x: hidden;\n}\n\nbody {\n  width:100%;\n}\n\n/* From here we override global bootstrap variable. You can see all root variables\n at https://getbootstrap.com/docs/5.3/customize/css-variables/ */\n\n:root,\n[data-bs-theme=light] {\n  --bs-font-sans-serif: 'Poppins', 'Manrope', Helvetica, sans-serif;\n  --bs-body-font-size: 0.92rem;\n\n  /* Light Farbschema */\n  color-scheme: light;\n\n  /* Schriftart und Basiseinstellungen */\n  --bs-font-sans-serif: 'Poppins', 'Manrope', Helvetica, sans-serif;\n  --bs-body-font-size: 0.92rem;\n\n  /* Farbvariablen für ein helles Schema */\n  --primary-color: rgb(59, 125, 221); /* Standard-Bootstrap-Blau */\n  --primary-light: #009EFF; /* Heller Farbton des Primärfarben */\n  --primary-lighter: #81adff; /* Ehemalig war das #7FB7F2 */\n  --primary-dark: #005CBF; /* Heller Farbton des Primärfarben */\n  --primary-darker: #354C80; /* Heller Farbton des Primärfarben */\n  --blue-color: #004085;   /* Tiefes Blau für Header und Akzente */\n  --secondary-color: #6c757d; /* Bootstrap-Dunkelgrau für Sekundärfarben */\n  --success-color: #e3e3e3; /* Bootstrap-Grün für Erfolgsfarben */\n  --info-color: #D1E8F0; /* Bootstrap-Hellblau für Infofarben */\n  --warning-color: #FFC800; /* Bootstrap-Gelb für Warnungen */\n  --danger-color: #811211;  /* Bootstrap-Rot für Fehlertexte */\n  --dark-color: #343a40;    /* Dunkles Grau für Texte und Header */\n\n\n\n  /* Helle Grautöne (angepasst an Bootstrap-Standards) */\n\n  --bs-gray-main: #f8f8f8;   /* für den standart main hintergund auf allen seiten */\n  --bs-gray-100: #f8f9fa;\n  --bs-gray-200: #e9ecef;\n  --bs-gray-300: #dee2e6;\n  --bs-gray-400: #ced4da;\n  --bs-gray-500: #adb5bd;   /* Standard Bootstrap-Grau */\n  --bs-gray-600: #6c757d;\n  --bs-gray-700: #495057;\n  --bs-gray-800: #343a40;\n  --bs-gray-900: #212529;   /* Tiefstes Grau für dunkle Akzente */\n  --bs-gray-middle: #4B5966;\n\n\n}\n\n:root,\n[data-bs-theme=dark] {\n  color-scheme: dark;\n  --bs-font-sans-serif: 'Poppins','Manrope', Helvetica, sans-serif;\n  --bs-body-font-size: 0.92rem;\n}\n\n/* From here we override default bootstrap styles. This should only be done when there was no solution\n  to override the default styles using the bootstrap variables or using the boostrap classes. */\n\n\n/* Shop Styles von Flo */\n\n:root {\n  --tenant-primary-color: #ed644c; /* Primary color for the tenant. Is overwritten in the layout file with the color from the backend */\n}\n\nbody {\n  font-family: 'Poppins', sans-serif; /* Sets the default font */\n}\n\n/* Definiere globale Variablen */\n:root {\n  --custom-gray: #757575; /* Dein gewählter Grauton */\n}\n\n\n\n/* Schriftformate für die Fotopakete */\n\n.packproduct-title {\n  font-family: 'Poppins', sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  color: rgb(75, 89, 102);\n}\n\n.packproduct-sub {\n  font-family: 'Poppins', sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  color: rgb(75, 89, 102);\n}\n\n.packproduct-subblack {\n  font-family: 'Poppins', sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  color: black;\n}\n\n.packproduct-price {\n  font-family: 'Poppins', sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  color: white;\n}\n\n.packproduct-price2 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  color: white;\n}\n\n.packproduct-price-old {\n  font-family: 'Poppins', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: rgb(119, 119, 119);\n}\n\n/* Schriftformate Einzelprodukte */\n\n.text-button1 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  color: rgb(119, 119, 119);\n  letter-spacing: 0.10px; /* Fügt einen Abstand von 1 Pixel zwischen den Zeichen hinzu */\n}\n\n.text-button1Price {\n  font-family: 'Poppins', sans-serif;\n  font-size: 15px;\n  font-weight: 400;\n  color: rgb(33, 37, 41);\n  letter-spacing: 0.32px;\n}\n\n\n/* Schriftformate für Shop Global */\n\n\n.section-head {\n  font-family: 'Poppins', sans-serif;\n  font-size: 22px;\n  font-weight: 600;\n  color: rgb(75, 89, 102);\n}\n\n.button-textinv {\n  font-family: 'Poppins', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  color: white;\n}\n\n.button-text {\n  font-family: 'Poppins', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: rgb(75, 89, 102);\n  letter-spacing: 0.60px;\n}\n\n/* Schriftformate für Shop*/\n\n.fs-photog-head1 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.fs-photog-PackPrice {\n  font-family: 'Poppins', sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n\n.fs-photog-13-200 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 13px;\n  font-weight: 200;\n}\n\n.fs-photog-14-200 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 14px;\n  font-weight: 200;\n}\n\n.fs-photog-15-200 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 15px;\n  font-weight: 200;\n}\n\n.fs-photog-16-200 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 16px;\n  font-weight: 200;\n}\n\n.fs-photog-18-200 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 18px;\n  font-weight: 200;\n}\n\n.fs-photog-20-200 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 20px;\n  font-weight: 200;\n}\n\n.fs-photog-20-300 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 20px;\n  font-weight: 300;\n}\n\n\n.fs-photog-20-700 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 20px;\n  font-weight: 700;\n}\n\n\n.fs-photog-30-200 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 30px;\n  font-weight: 200;\n}\n\n\n\n\n\n\n\n.fs-photog-12-400 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.fs-photog-12-600 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.fs-photog-13-300 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 13px;\n  font-weight: 300;\n}\n.fs-photog-13-400 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n}\n\n\n\n.fs-photog-13-600 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.fs-photog-14-300 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 14px;\n  font-weight: 300;\n}\n\n\n.fs-photog-14-400 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.fs-photog-14-600 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n\n.fs-photog-15-300 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 15px;\n  font-weight: 300;\n\n}\n\n\n.fs-photog-15-500 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  letter-spacing: 0.32px;\n}\n\n.fs-photog-15-600 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: 0.32px;\n}\n\n\n.fs-photog-16-600 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.fs-photog-16-400 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n\n\n.fs-photog-24-200 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 24px;\n  font-weight: 200;\n}\n.fs-photog-24-300 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 24px;\n  font-weight: 300;\n}\n\n\n.fs-photog-24-400 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 24px;\n  font-weight: 400;\n}\n\n.fs-photog-24-600 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.fs-photog-24-800 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 24px;\n  font-weight: 800;\n}\n\n.fs-photog-24-900 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 24px;\n  font-weight: 900;\n}\n\n.fs-photog-30-400 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 30px;\n  font-weight: 400;\n}\n\n\n\n\n.fs-photog-18b {\n  font-family: 'Poppins', sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n\n.fs-photog-20-400 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 20px;\n  font-weight: 400;\n}\n\n\n.fs-photog-17-500 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 17px;\n  font-weight: 500;\n  letter-spacing: 0.60px;\n}\n\n.fs-photog-30-200 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 30px;\n  font-weight: 200;\n}\n\n\n.fs-photog-16-300-button {\n  font-family: 'Poppins', sans-serif;\n  font-size: 16px;\n  font-weight: 300;\n  letter-spacing: 0.40px;\n}\n\n\n\n\n\n\n/* Textcolor */\n\n.text-photog {\n  color: #ed644c; /* Photographer Color */\n}\n\n.text-shopgray {\n  color: var(--custom-gray); /* Verwende den Grauton für Text */\n}\n\n\n.text-color1 {\n  color: rgb(33, 37, 41);\n}\n\n.text-lightgray {\n  color: rgb(119, 119, 119);\n}\n\n.text-middlegray {\n  color: rgb(75, 89, 102);\n}\n\n\n\n/* Background color */\n.bg-photog {\n  background-color: var(--tenant-primary-color); /* Photographer Color */\n}\n\n.bg-shopgray {\n  background-color: var(--custom-gray); /* Verwende den Grauton als Hintergrundfarbe */\n}\n\n.bg-gray-100 {\n  background-color: var(--bs-gray-100); /* Verwende den Grauton als Hintergrundfarbe */\n}\n.bg-gray-200 {\n  background-color: var(--bs-gray-200); /* Verwende den Grauton als Hintergrundfarbe */\n}\n\n.bg-lightgray {\n  background-color: rgb(119, 119, 119);\n}\n\n\n\n\n\n/* border outline */\n.border-outline {\n  border: 1px solid rgb(33, 37, 41); /* Breite, Stil und Farbe der Border */\n}\n\n\n\n\n\n\n\n\n\n/* Button */\n\n.btn-shopgray {\n  background-color: #dedede; /* Verwende den Grauton als Hintergrundfarbe */\n  transition: opacity 0.3s ease; /* Glatter Übergang für Opazität */\n}\n  .btn-shopgray:hover {\n    background-color: #dedede; /* Verwende den Grauton als Hintergrundfarbe */\n    opacity: 0.7;\n  }\n\n\n\n.btn-shopgrayMed {\n  background-color: rgb(75, 89, 102); /* Verwende den Grauton als Hintergrundfarbe */\n}\n\n.btn-photogColour {\n  background-color: var(--tenant-primary-color); /* Photographer Color */\n  transition: opacity 0.3s ease; /* Glatter Übergang für Opazität */\n}\n\n\n  .btn-photogColour:hover {\n    background-color: rgb(119, 119, 119);\n    opacity: 0.5;\n  }\n\n\n.hover-effect {\n  text-decoration: none;\n}\n\n  .hover-effect:hover {\n    color: #a0a0a0; /* Ändern Sie die Farbe nach Ihren Wünschen */\n  }\n\n\n/* ---------------------custom-radio for the Favourite Buttons in the Single-Foto Section*/\n.custom-radio {\n  padding: 7px;\n  border: 1px solid #ccc;\n  border-radius: 0.25rem;\n  display: block;\n  width: 100%;\n  text-align: left;\n  background-color: #f8f9fa;\n  color: #212529;\n  cursor: pointer;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n\n  .custom-radio:hover {\n    background-color: #e2e6ea;\n  }\n\ninput[type=\"radio\"]:checked + .custom-radio {\n  /*  background-color: var(--tenant-primary-color);*/ /* Blauer Hintergrund, wenn ausgewählt */\n  background-color: white;\n  /*color: white;*/\n  border: 2px solid var(--tenant-primary-color) !important; /* Schwarze Border */\n}\n\n.custom-radio input[type=\"radio\"] {\n  margin-right: 10px;\n}\n\n.custom-radio-price {\n  display: block;\n  font-size: 0.9rem;\n  color: #007bff;\n}\n\n\n\n\n\n\n\n\n\n\n\n/* Button Bild Tauschen überm Foto */\n\n\n\n\n\n/* Dicke Linie */\n.thick-divider {\n  border-top: 10px solid var(--custom-gray); /* Verwende die definierte Variable */\n}\n\n.normal-divider {\n  border-top: 3px solid var(--custom-gray); /* Verwende die definierte Variable */\n}\n\n\n\n\n.square-container {\n  width: 100%; /* Setzt die Breite des Containers auf 100% des übergeordneten Elements */\n  aspect-ratio: 1; /* 1:1 Verhältnis */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden; /* Verhindert, dass Inhalte außerhalb des Containers angezeigt werden */\n}\n\n\n\n\n\n.img-singleProduct {\n  max-width: 100%; /* Sorgt dafür, dass das Bild maximal so breit wie der Container ist */\n  max-height: 100%; /* Sorgt dafür, dass das Bild maximal so hoch wie der Container ist */\n  object-fit: contain; /* Verhindert, dass das Bild verzerrt wird */\n}\n\n/* ----------Flo new May 2025--------------------*/\n\n.card-product {\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  border: 1px solid #ededed;\n  overflow-x: hidden;\n  background-color: white;\n}\n.card-bl-flex {\n  border-radius: 12px;\n  padding: 25px 23px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  border: 1px solid #ededed;\n}\n\n\n\nh3 {\n  font-family: 'Poppins', sans-serif !important;\n  font-size: 24px !important;\n  font-weight: 800 !important;\n  color: var(--bs-gray-middle) !important;\n  margin: 0 !important;\n}\n\n\np {\n  font-family: 'Poppins', sans-serif !important;\n  font-size: 14px !important;\n  font-weight: 300 !important;\n  color: var(--bs-gray-middle) !important;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n.text-body-light {\n  font-family: 'Poppins', sans-serif !important;\n  font-size: 14px !important;\n  font-weight: 300 !important;\n  color: var(--bs-gray-middle) !important;\n}\n\n.text-btn {\n  font-family: 'Poppins', sans-serif !important;\n  font-size: 15px !important;\n  font-weight: 400 !important;\n  color: var(--bs-gray-middle);\n}\n\n\n\n.text-body-bold {\n  font-family: 'Poppins', sans-serif !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  color: var(--bs-gray-middle) !important;\n}\n\n.btn-height {\n  height: 35px !important;\n  display: flex !important;\n  align-items: center !important;\n  margin:0 !important;\n  padding:0 !important;\n}\n\n.product-small {\n  max-height: 80%;\n  max-width: 80%;\n}\n\n.product-medium {\n  max-height: 90%;\n  max-width: 90%;\n}\n\n.product-large {\n  max-height: 100%;\n  max-width: 100%;\n}\n\n.test-mode-banner {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 2000;\n}\n\n\n.mt-custom {\n  margin-top: calc(60px + 40px);\n}\n\n.fixed-header {\n  top: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
